export default __webpack_public_path__ + "static/media/link-list-icon.8dd1771c.svg";